import { ThemeProvider } from "@mui/material";
import { isAndroidPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";
import { getSafeAreaPaddings, getTheme } from "@src/appV2/redesign/system/ui-theme";
import { Route, useRouteMatch } from "react-router-dom";

import { PageWrapper } from "../components/PageWrapper";
import { Navbar } from "../Navbar";
import { FeedPage } from "./FeedPage";
import { FEED_PATH } from "./paths";

export function SocialContainer() {
  const match = useRouteMatch();

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper
        sx={(theme) => ({
          // On iOS, the Capacitor WKWebView natively offsets content below the
          // safe area — adding explicit padding without a header makes the gap
          // look too large. On Android with edge-to-edge enabled, content
          // extends behind the status bar. Other pages handle this via
          // PageHeaderWrapper, but this page has no native header (the header
          // lives inside the iframe), so we add the padding ourselves.
          ...(isAndroidPlatform() &&
            getSafeAreaPaddings({ top: true, fallbackTop: theme.spacing(3) })),
          backgroundColor: theme.palette.background.tertiary,
        })}
      >
        <Route path={`${match.url}/${FEED_PATH}`}>
          <FeedPage />
        </Route>
        <Navbar />
      </PageWrapper>
    </ThemeProvider>
  );
}
